import { createAction } from "@reduxjs/toolkit"

import type { List } from "@/api/lists"
import type { DenormalizedTargetAttribute, DenormalizedTemplate } from "@/api/templates"
import type { ListAndWorkspaceId } from "@/redux/lists"

// WORKSPACE ACTIONS
// Workspace create/update write directly to the React Query cache (see
// `useWorkspacesCache`). `deleteWorkspaceById` remains because the `lists` slice
// cascades on it to drop the deleted workspace's lists.
export const deleteWorkspaceById = createAction<number>("workspaces/delete-by-id")

// LIST ACTIONS
export const createLists = createAction<List[]>("lists/create")
export const updateList = createAction<Partial<List>>("lists/update")
export const updateListWorkspaceId = createAction<{
  workspaceId: number
  listId: number
  newWorkspaceId: number
}>("lists/move-workspace")
export const deleteListById = createAction<ListAndWorkspaceId>("lists/delete")

// TEMPLATE ACTIONS
export const createTemplate = createAction<DenormalizedTemplate>("templates/create")
export const updateTemplate = createAction<DenormalizedTemplate>("templates/update")
export const deleteTemplateById = createAction<number>("templates/delete")

// TARGET ATTRIBUTE ACTIONS
export const createTargetAttribute = createAction<{
  templateId: number
  targetAttribute: DenormalizedTargetAttribute
}>("target-attributes/create")
export const updateTargetAttribute = createAction<DenormalizedTargetAttribute>(
  "target-attributes/update",
)
export const reorderTargetAttributes = createAction<{
  templateId: number
  oldIndex: number
  newIndex: number
}>("target-attributes/reorder")
export const deleteTargetAttributeById = createAction<{ templateId: number; id: number }>(
  "target-attributes/delete",
)
